// JS que activa y desactiva clases CSS desde un elemnto HTML a otro. Ej. Boton vista rapida cards de productos, abrir menu mobile

$(document).ready(function(){
    // variables

    // acciones
    $('body').on('click', '.js-pop__action', function(event) {
        popContent($(this))
        popButton($(this))
    })

    // funciones
    function popContent(action) {
        $('.js-pop__content').each( function (){
            if ( action.data('pop__id') == $(this).data('pop__id') ) {
                $(this).toggleClass($(this).data('pop__active'))
            }
        })
    }

    function popButton(action) {
        $('.js-pop__action').each( function (){
            if ( action.data('pop__id') == $(this).data('pop__id') ) {
                $(this).toggleClass($(this).data('pop__active'))
            }
        })
    }
})